module.exports = __webpack_public_path__ + "static/media/Campus-Inactive.69b162ef.svg";